import React from "react";

import styles from "./SideModal.module.css";

import Modal from "../modal/Modal";

const SideModal = ({
  children,
  side,
  open,
  setOpen,
  trigger,
  closeIconProps,
}) => {
  return (
    <div className={styles.SideModalContainer}>
      {trigger}
      <Modal
        {...{
          open,
          setOpen,
          children,
          side,
          closeIconProps,
          className: styles.SideModalWrapper,
        }}
      />
    </div>
  );
};

export default SideModal;
